/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit New/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AddInvoiceAction from './AddInvoiceAction/index'
import AppliedPayments from './AppliedPayments/index'
import CreatePaymentPlanForExistingInvoiceAction from './CreatePaymentPlanForExistingInvoiceAction/index'
import EditAutopayAction from './EditAutopayAction/index'
import PaymentPlans from './PaymentPlans/index'
import PaymentsTransactions from './PaymentsTransactions/index'
import PostPaymentAction from './PostPaymentAction/index'
import PostPaymentToReceivableAction from './PostPaymentToReceivableAction/index'
import React from 'react'
import Receivables from './Receivables/index'
import RefundCardPaymentAction from './RefundCardPaymentAction/index'
import RequestPaymentAction from './RequestPaymentAction/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import UnappliedPayments from './UnappliedPayments/index'
import VaxiomPayments from './VaxiomPayments/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function New({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="New.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-l16': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-2-l16': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-l16': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="New.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="New.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<PostPaymentAction
  viewPath={`${viewPath}/PostPaymentAction`}
/>
<PostPaymentToReceivableAction
  viewPath={`${viewPath}/PostPaymentToReceivableAction`}
/>
<RequestPaymentAction
  viewPath={`${viewPath}/RequestPaymentAction`}
/>
<EditAutopayAction
  viewPath={`${viewPath}/EditAutopayAction`}
/>
<CreatePaymentPlanForExistingInvoiceAction
  viewPath={`${viewPath}/CreatePaymentPlanForExistingInvoiceAction`}
/>
<AddInvoiceAction
  viewPath={`${viewPath}/AddInvoiceAction`}
/>
<RefundCardPaymentAction
  viewPath={`${viewPath}/RefundCardPaymentAction`}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="(To create payment account for this patient, post a payment on [NEW]) (Cache invalidation not implemented yet - reload might be needed)"
/>
</div>
<VaxiomPayments
  viewPath={`${viewPath}/VaxiomPayments`}
/>
<AppliedPayments
  viewPath={`${viewPath}/AppliedPayments`}
/>
<UnappliedPayments
  viewPath={`${viewPath}/UnappliedPayments`}
/>
<PaymentsTransactions
  viewPath={`${viewPath}/PaymentsTransactions`}
/>
<Receivables
  viewPath={`${viewPath}/Receivables`}
/>
<PaymentPlans
  viewPath={`${viewPath}/PaymentPlans`}
/>
</div>
{children}
</React.Fragment>)
}